import React from "react";

export default function AuthorsSVG(props) {
  return (
    <svg
      width={props.size ? props.size : "19"}
      height={props.size ? props.size : "19"}
      viewBox={props.viewBox ? props.viewBox : "0 0 16 18"}
      fill={props.fill ? props.fill : "white"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.60184 17.1174C5.21844 17.1233 2.89567 16.7478 0.632032 16.0048C0.0347041 15.8089 -0.0872749 15.5664 0.146333 14.9787C0.876729 13.1379 1.61674 11.3009 2.35009 9.46157C2.4632 9.17695 2.6591 9.03206 2.96959 9.03427C3.6719 9.03797 4.3742 9.04019 5.07576 9.03427C5.25689 9.03279 5.40991 9.09637 5.56812 9.16734C6.8781 9.75506 8.1903 9.7558 9.49954 9.16512C9.67031 9.08824 9.83738 9.03058 10.0289 9.03206C10.706 9.03797 11.3839 9.03945 12.0611 9.03132C12.4019 9.02762 12.6059 9.17843 12.7316 9.49484C13.4539 11.3127 14.1887 13.1254 14.9125 14.9425C15.1719 15.5945 15.0344 15.8474 14.3602 16.061C12.1609 16.7574 9.91057 17.1211 7.60184 17.1174Z"
        fill={props.fill ? props.fill : "white"}
      />
      <path
        d="M7.54817 0.957076C9.78076 0.968165 11.5994 2.79415 11.5831 5.00826C11.5668 7.23345 9.74231 9.04022 7.51786 9.03431C5.29636 9.02839 3.47407 7.19575 3.48442 4.97795C3.49403 2.75202 5.31928 0.946726 7.54817 0.957076Z"
        fill={props.fill ? props.fill : "white"}
      />
    </svg>
  );
}
